import { createContext, useState } from 'react';

const baseUrl = 'https://api.themoviedb.org/3/discover/movie?api_key=fa95cddfa25a27f18e30bbdbd383054b&language=en-US&sort_by=popularity.desc&include_video=true&include_adult=false';
const boolywoodMoviesUrlPart = '&certification_country=IN&certification=UA&primary_release_date.gte=2000-01-02&with_original_language=hi&page=';
const hollywoodMoviesUrlPart = '&with_genres=28&certification_country=US&certification=PG-13&primary_release_date.gte=2000-01-02&with_original_language=en&page=';

const baseUrlForOptions = 'https://api.themoviedb.org/3/movie/';
const optionsMoviesUrlPart = '?api_key=fa95cddfa25a27f18e30bbdbd383054b&language=en-US&page=1';


const TriviaContext = createContext({
    movieCategory: null,
    setMovieCategory: (movieCategory) => { },

    isOptionSelectedByUser: false,
    setIsOptionSelectedByUser: (value) => { },

    triviaStatus: null,
    setTriviaStatus: (qno, status) => { },

    currentQuestionNo: 0,
    setNextQuestion: () => { },

    populateQuestion: (qno, levelNo) => { },

    resetTriviaStatus: () => { }
});

function setDefaultTriviaStatus() {
    let questionsStatus = [];

    for (let index = 0; index < 5; index++) {
        const element = {
            qno: index,
            result: null,
            current: index === 0 ? true : false,
        }
        questionsStatus.push(element);
    }
    return questionsStatus;
}

export function TriviaContextProvider(props) {
    // CONTEXT STATE
    const [movieCategory, setMovieCategory] = useState();
    const [isOptionSelectedByUser, setIsOptionSelectedByUser] = useState(false);
    const [triviaStatus, setTriviaStatus] = useState(setDefaultTriviaStatus());
    const [currentQuestionNo, setCurrentQuestionNo] = useState(0);
    const [generatedIndexes, setGeneratedIndexes] = useState([]);

    // CONTEXT OPRATIONS
    function setMovieCategoryHandler(movieCategory) {
        setMovieCategory(movieCategory);
    }

    function setIsOptionSelectedByUserHandler(value) {
        setIsOptionSelectedByUser(value);
    }

    function setNextQuestionHandler() {
        setTriviaStatus_current(currentQuestionNo, false);
        setTriviaStatus_current(currentQuestionNo + 1, true);
        setCurrentQuestionNo(currentQuestionNo + 1);
    }

    function setTriviaStatus_current(qno, status) {
        setTriviaStatus((prevTriviaStatus) => {
            let modifiedTriviaStatus = prevTriviaStatus;
            modifiedTriviaStatus[qno].current = status;
            return modifiedTriviaStatus;
        });
    }

    function setTriviaStatusHandler(qno, status) {
        setTriviaStatus((prevTriviaStatus) => {
            let modifiedTriviaStatus = prevTriviaStatus;
            modifiedTriviaStatus[qno].result = status;
            return modifiedTriviaStatus;
        });
    }


    async function getQuestionOptions_MovieNames(movieId) {
        try {
            //let foundMoviesCount = 0;
            let foundMovies;

            // Attempt max 2 times to try to fetch a movies for options
            for (let index = 0; index < 2; index++) {
                const url = baseUrlForOptions + movieId + (index === 0 ? '/recommendations' : '/similar') + optionsMoviesUrlPart;

                try {
                    const response = await fetch(url);

                    if (response.ok) {
                        const movies = await response.json();
                        if (movies && movies.results.length > 4) {
                            //foundMoviesCount = movies.results.length;
                            foundMovies = movies.results;
                            break;
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
            }

            // Even after max attempts didn't get the movie throw error
            if (!foundMovies) {
                return null;
            }

            let options = [];

            for (let index = 0; index < 4; index++) {

                let optionMovieTitile;
                for (let i = 0; i < 4; i++) {
                    const movie = foundMovies[index]; // Math.floor(Math.random() * foundMoviesCount) + 1

                    if (movie && movie.title) {
                        optionMovieTitile = movie.title;
                        break;
                    }
                }

                if (optionMovieTitile) {
                    options.push(optionMovieTitile);
                } else {
                    console.error('Error:', 'Not found the name of option movie.');
                    options = [];
                    break;
                }
            }

            if (options && options.length === 4) {
                return options;
            } else {
                return null;
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function getQuestionOptions_CastNames(movieId) {
        try {
            let foundCasts;

            // Attempt max 2 times to try to fetch a movies for options
            for (let index = 0; index < 2; index++) {
                const url = baseUrlForOptions + movieId + '/credits' + optionsMoviesUrlPart;

                try {
                    const response = await fetch(url);

                    if (response.ok) {
                        const casts = await response.json();

                        if (casts && casts.cast.length > 4) {
                            foundCasts = casts.cast;
                            break;
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
            }

            // Even after max attempts didn't get the movie throw error
            if (!foundCasts) {
                return null;
            }

            let options = [];

            for (let index = 0; index < 4; index++) {
                const cast = foundCasts[index];

                if (cast && cast.name && cast.character) {
                    let optionCast = {
                        name: cast.name,
                        character: cast.character,
                        profile_path: cast.profile_path
                    }
                    options.push(optionCast);
                } else {
                    console.error('Error:', 'Not found the name of option movie.');
                    options = [];
                    break;
                }
            }

            if (options && options.length === 4) {
                return options;
            } else {
                return null;
            }
        } catch (error) {
            console.log(error);
        }
    }


    async function populateQuestionHandler(qno, levelNo) {
        try {

            const movieUrlPartBySelectedCategory = movieCategory === 'Bollywood' ? boolywoodMoviesUrlPart : hollywoodMoviesUrlPart;
            //const movieAvailablePages = movieCategory === 'Bollywood' ? 20 : 40;
            let movieForQuestion;

            // Attempt max 5 times to try to fetch a movie for question
            for (let index = 0; index < 5; index++) {
                try {
                    const url = baseUrl + movieUrlPartBySelectedCategory + (levelNo ? levelNo : 1); // (Math.floor(Math.random() * movieAvailablePages) + 1).toString();
                    const response = await fetch(url);
//debugger;
                    if (response.ok) {
                        const movies = await response.json();
                        if (movies && movies.results.length > 0) {
                            let generatedIndex;
                            do {
                                generatedIndex = (Math.floor(Math.random() * 20) + 1);
                            } while (generatedIndexes?.includes(generatedIndex));

                            setGeneratedIndexes((prevIndexes) => {
                                let indexes = prevIndexes;
                                indexes?.push(generatedIndex);
                                return indexes;
                            });

                            const movie = movies.results[generatedIndex];

                            if (movie && movie.id && movie.title && movie.backdrop_path) {
                                movieForQuestion = movie;
                                // Break as we got our movie
                                break;
                            }
                        }

                    }
                } catch (error) {
                    console.log(error);
                }
            }

            // Even after max attempts didn't get the movie throw error
            if (!movieForQuestion) {
                return null;
            }

            switch (qno) {
                case 0:
                case 2: {
                    const options = await getQuestionOptions_MovieNames(movieForQuestion.id);

                    if (!options) {
                        return null;
                    }

                    const rightOptionIndex = Math.floor(Math.random() * 3);

                    options[rightOptionIndex] = movieForQuestion.title;

                    const question = {
                        qno: 1,
                        qtext: 'Q. Guess a movie by poster.',
                        qimg: 'https://image.tmdb.org/t/p/w780' + movieForQuestion.backdrop_path,
                        options,
                        answerIndex: rightOptionIndex,
                        overview: movieForQuestion.overview
                    }
                    return question;
                }
                case 1:
                case 4: {
                    const options = await getQuestionOptions_CastNames(movieForQuestion.id);

                    if (!options) {
                        return null;
                    }

                    let rightOptionIndex;
                    for (let index = 0; index < 4; index++) {
                        let generatedIndex;
                        if (levelNo < 3) {
                            generatedIndex = 0;
                        } else if (levelNo < 6) {
                            generatedIndex = Math.floor(Math.random() * 2);
                        } else {
                            generatedIndex = Math.floor(Math.random() * 3);
                        }
                        if (options[generatedIndex].profile_path) {
                            rightOptionIndex = generatedIndex;
                            break;
                        }
                    }
                    if (rightOptionIndex === undefined) {
                        return null;
                    }
                    const question = {
                        qno: 1,
                        qtext: `Q. Which role "${options[rightOptionIndex].name}" played in movie "${movieForQuestion.title}"?`,
                        qimg: 'https://image.tmdb.org/t/p/w500' + movieForQuestion.poster_path,
                        qimg2: 'https://image.tmdb.org/t/p/h632' + options[rightOptionIndex].profile_path,
                        options: options.map(cast => cast.character),
                        answerIndex: rightOptionIndex,
                        overview: movieForQuestion.overview
                    }
                    return question;
                }
                case 3: {
                    if (!movieForQuestion.release_date) {
                        return null;
                    }

                    const releaseDate = new Date(movieForQuestion.release_date);
                    const releaseYear = releaseDate.getFullYear();

                    if (!releaseYear) {
                        return null;
                    }

                    let options = [];

                    const start = new Date(2000, 1, 1);
                    const end = new Date()
                    for (let index = 0; index < 4; index++) {
                        let randDateYear;
                        do {
                            randDateYear = new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime())).getFullYear();
                        } while (randDateYear === releaseYear);
                        options.push(randDateYear);
                    }

                    const rightOptionIndex = Math.floor(Math.random() * 3);
                    options[rightOptionIndex] = releaseYear;

                    const question = {
                        qno: 2,
                        qtext: `Q. Which year movie "${movieForQuestion.title}" got released?`,
                        qimg: 'https://image.tmdb.org/t/p/w500' + movieForQuestion.poster_path,
                        qimg2: 'https://image.tmdb.org/t/p/w780' + movieForQuestion.backdrop_path,
                        options,
                        answerIndex: rightOptionIndex,
                        overview: movieForQuestion.overview
                    }
                    return question;
                }
                default:
                    break;
            }
            return null;

        } catch (error) {
            console.log(error);
        }
    }

    function resetTriviaStatusHandler() {
        //setMovieCategory(null);
        setIsOptionSelectedByUser(false);
        setTriviaStatus(setDefaultTriviaStatus());
        setCurrentQuestionNo(0);
        setGeneratedIndexes([]);
    }

    // CONTEXT DATA
    const context = {
        movieCategory: movieCategory,
        setMovieCategory: setMovieCategoryHandler,

        isOptionSelectedByUser: isOptionSelectedByUser,
        setIsOptionSelectedByUser: setIsOptionSelectedByUserHandler,

        triviaStatus: triviaStatus,
        setTriviaStatus: setTriviaStatusHandler,

        currentQuestionNo: currentQuestionNo,
        setNextQuestion: setNextQuestionHandler,

        populateQuestion: populateQuestionHandler,

        resetTriviaStatus: resetTriviaStatusHandler
    }

    return (
        <TriviaContext.Provider value={context}>
            {props.children}
        </TriviaContext.Provider>
    )
}

export default TriviaContext;
